"use-strict";

class StickyAddCart extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.getHeightAddToCart();
    const btn_minimal = this.querySelector("minimal-button");
    if (btn_minimal) {
      btn_minimal.addEventListener("click", this.toggle.bind(this), false);
    }
  }
  getHeightAddToCart() {
    const _this = this;
    this.main = this.closest(".sec__featured-product");
    if (!this.main) return;
    const primaryBtn = this.main.querySelector(".button-trigger__sticky");
    const footer = document.querySelector(".product-sticky-hide");

    if (!primaryBtn) return;

    var isVisible = true;
    window.addEventListener("scroll", function () {
      var buttonRect = primaryBtn.getBoundingClientRect();
      var viewportHeight = window.innerHeight;
      if (footer) {
        var footerRect = footer.getBoundingClientRect();
        if (footerRect.top < window.innerHeight - 100) {
          _this.classList.remove("show-sticky-cart");
          isVisible = true;
        } else {
          if (
            !isVisible &&
            buttonRect.top < viewportHeight &&
            buttonRect.bottom > 0
          ) {
            isVisible = true;
            _this.classList.remove("show-sticky-cart");
          } else if (isVisible && buttonRect.bottom <= 0) {
            isVisible = false;
            _this.classList.add("show-sticky-cart");
          }
        }
      } else {
        if (
          !isVisible &&
          buttonRect.top < viewportHeight &&
          buttonRect.bottom > 0
        ) {
          isVisible = true;
          _this.classList.remove("show-sticky-cart");
        } else if (isVisible && buttonRect.bottom <= 0) {
          isVisible = false;
          _this.classList.add("show-sticky-cart");
        }
      }
    });
  }
  toggle(e) {
    const target = e.currentTarget;
    target.classList.toggle("opened");
    if (!target) return;
    const parent = target.closest("sticky-add-cart");
    if (!parent) return;
    const content = parent.querySelector(".content--expand");
    slideAnime({
      target: content,
      animeType: "slideToggle",
    });
  }
}
customElements.define("sticky-add-cart", StickyAddCart);
// js for fake sold
class SoldProduct extends HTMLElement {
  constructor() {
    super();
    this.sold = this.dataset.sold;
    this.hours = this.dataset.hours;
    this.message = this.dataset.message;
    this.init();
  }
  init() {
    if (this.message && this.sold && this.hours) {
      var message = "";
      message = this.message
        .replace("{{ sold }}", this.randomSelect(this.sold))
        .replace("{{ hours }}", this.randomSelect(this.hours));
      this.innerHTML += message;
    }
  }

  randomSelect(numbers) {
    const numberArray = numbers.split(",");
    const randomIndex = Math.floor(Math.random() * numberArray.length);
    const randomNumber = numberArray[randomIndex];
    return randomNumber;
  }
}
customElements.define("sold-product", SoldProduct);

// js for live view
class LiveView extends HTMLElement {
  constructor() {
    super();
    this.min = this.dataset.min;
    this.max = this.dataset.max;
    this.interval = this.dataset.interval;
    this.message = this.dataset.message;
    this.init();
  }
  init() {
    if (this.message && this.max && this.min && this.interval) {
      this.handle();
      setInterval(() => {
        this.handle();
      }, this.interval * 1000);
    }
  }

  handle() {
    var message = "";
    message = this.message.replace(
      "[count]",
      this.randomSelect(parseInt(this.min), parseInt(this.max))
    );
    this.innerHTML = message;
  }

  randomSelect(min, max) {
    const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
    return randomNumber;
  }
}
customElements.define("live-view", LiveView);



class CompareRadios extends SwatchInit {
  constructor() {
    super();
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.init();
    this.initFunction();
  }

  initFunction() {
    this.querySelectorAll(".product__color-swatches--js").forEach((btn) => {
      btn.addEventListener("click", this.onVariantChange.bind(this), false);
    });
  }

  onVariantChange(e) {
    e.preventDefault();
    const target = e.currentTarget;
    target.classList.toggle("active");
    this.handleWhenSwatchUpdate();
  }

  handleWhenSwatchUpdate() {
    this.updateOptions();
    const arrayItem = this.updateMasterId(this.variantData);
    this.handleMediaCompare(arrayItem);
  }

  handleMediaCompare(arrayItem) {
    if (!arrayItem) return;
    const html = `
            ${arrayItem
              .map((item) => {
                return `
                <div class="compare__items-inner">
                        <img width="300px" height="300px" src="${item.featured_media.preview_image.src}" alt="${item.featured_media.alt}">
                        <p class="mb-0 mt-10 heading-style capitalize">${item.title}</p></div>
                    `;
              })
              .join("")}
        `;
    const compareColorContent = this.closest(".compare-colors__content");
    if (!compareColorContent) return;
    const compareItems = compareColorContent.querySelector(".compare__items");
    if (!compareItems) return;
    compareItems.innerHTML = html;
  }

  updateMasterId(variantData) {
    let arrayItem = [];
    this.options.forEach((option) => {
      const matchingVariant = variantData.find((variant) => {
        return variant.options.includes(option);
      });
      if (matchingVariant) {
        arrayItem.push(matchingVariant);
      }
    });
    return arrayItem;
  }
}
customElements.define("compare-radios", CompareRadios);

class ProductRecommendations extends SlideSection {
  constructor() {
    super();
  }
  init() {
    this.call();
  }
  call() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          if (recommendations.innerHTML.trim().length === 0) {
            // this.remove();
            this.style.display = "none";
            if (document.querySelector(".product-recommendations-heading")) {
              document
                .querySelector(".product-recommendations-heading")
                .remove();
            }
          }
        })
        .finally(() => {
          if (this.querySelector(".swiper-wrapper")) {
            this.initSlide();
            BlsAnimations.init();
            BlsLazyloadImg.init();
          }
          initLazyloadItem();
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("product-recommendations", ProductRecommendations);

// js for live view
class SkeletonPage extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    window.setTimeout(() => {
      this.classList.remove("skeleton");
    }, 1500);
  }
}
customElements.define("skeleton-page", SkeletonPage);

// js for live view
class ProductGrouped extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    var group = this.querySelector('.productGroup[type="application/json"]');
    if (!group) return;
    var variantData = JSON.parse(group.innerText);
    var query = "";
    variantData.forEach((e, key, variantData) => {
      if (!Object.is(variantData.length - 1, key)) {
        query += e + "%20OR%20id:";
      } else {
        query += e;
      }
    });
    var productAjaxURL = "?q=id:" + query + "&section_id=product-grouped";
    fetch(`${window.routes.search_url}${productAjaxURL}`)
      .then((response) => response.text())
      .then(async (responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        this.innerHTML = html.querySelector(".product-group").innerHTML;
      })
      .catch((e) => {
        throw error;
      })
      .finally(() => {
        this.eventProductGroupAction();
      });
  }

  eventProductGroupAction() {
    document
      .querySelectorAll(".product-group-list .product-variant-option")
      .forEach((select) => {
        select.addEventListener(
          "change",
          (event) => {
            var target = event.target;
            var image =
                target.options[target.selectedIndex].getAttribute("data-image"),
              price =
                target.options[target.selectedIndex].getAttribute("data-price"),
              pro_handle = target.getAttribute("data-handle"),
              image =
                target.options[target.selectedIndex].getAttribute("data-image"),
              price =
                target.options[target.selectedIndex].getAttribute("data-price"),
              pro_handle = target.getAttribute("data-handle"),
              compare_price =
                target.options[target.selectedIndex].getAttribute(
                  "data-compare-price"
                );
            var img = target
              .closest(".product-group-list")
              .querySelector(".product-group-item ." + pro_handle + "")
              .querySelector("img");
            if (img) {
              img.removeAttribute("srcset");
              img.setAttribute("src", image);
            }
            const productTarget = target.closest(".product-group-item");
            const bls__price = productTarget.querySelector(
              ".product-item__price .card-product-price"
            );
            if (bls__price) {
              if (!bls__price.querySelector(".compare-price")) {
                var ps = document.createElement("div");
                var sp = document.createElement("span");
                var cp = document.createElement("s");
                cp.classList.add("price-item", "compare-price");
                sp.appendChild(cp);
                ps.appendChild(sp);
                ps.classList.add("price-regular");
                if (productTarget.querySelector(".card-product-price")) {
                  productTarget
                    .querySelector(".card-product-price")
                    .appendChild(ps);
                }
              }
              const cpp = bls__price.querySelector(".compare-price");

              if (cpp) {
                if (compare_price && compare_price > price) {
                  const compare_format = Shopify.formatMoney(
                    compare_price,
                    themeGlobalVariables.settings.money_format
                  );
                  cpp.innerHTML = compare_format;
                  if (bls__price.querySelector(".price-regular")) {
                    bls__price
                      .querySelector(".price-regular")
                      .classList.add("primary-color");
                  }
                  if (bls__price.querySelector(".price-regular .price")) {
                    bls__price
                      .querySelector(".price-regular .price")
                      .classList.add("price--special");
                  }
                } else {
                  cpp.innerHTML = "";
                  if (bls__price.querySelector(".price-regular")) {
                    bls__price
                      .querySelector(".price-regular")
                      .classList.remove("primary-color");
                  }
                  if (bls__price.querySelector(".price-regular .price")) {
                    bls__price.querySelector(
                      ".price-regular .price"
                    ).innerHTML = Shopify.formatMoney(
                      price,
                      cartStrings.money_format
                    );
                    bls__price
                      .querySelector(".price-regular .price")
                      .classList.remove("price--special");
                  }
                }
              }
            }
            target.setAttribute("data-price", price);
            target.setAttribute("data-compare-price", compare_price);
          },
          false
        );
      });

    let totalQty = 0;
    const classQty = document.querySelectorAll(
      ".quantity__input-product-group"
    );
    classQty.forEach((input) => {
      let valueQtyDefault = input.value;
      let valueAsDefault = parseFloat(valueQtyDefault);
      if (!isNaN(valueAsDefault)) {
        totalQty += valueAsDefault;
      }
      input.addEventListener("change", () => {
        totalQty = 0;
        classQty.forEach((value) => {
          let valueQty = value.value;
          let valueAsQty = parseFloat(valueQty);
          if (!isNaN(valueAsQty)) {
            totalQty += valueAsQty;
          }
        });
      });
    });
    document.querySelectorAll(".product-group-submit").forEach((button) => {
      button.addEventListener(
        "click",
        (event) => {
          if (totalQty === 0) {
            const content = document.querySelector(
              ".form-infor .add-cart-error"
            );
            const messageErrQty = button.getAttribute("data-add-cart-err-qty");
            handleErrorMessagePopup(messageErrQty);
            if (!content) return;
          } else {
            this.submitProductGroup(event);
          }
        },
        false
      );
    });

    document.querySelectorAll(".product-group-buy-now").forEach((button) => {
      button.addEventListener(
        "click",
        (event) => {
          if (totalQty === 0) {
            const content = document.querySelector(
              ".form-infor .add-cart-error"
            );
            const messageErrQty = button.getAttribute("data-add-cart-err-qty");
            handleErrorMessagePopup(messageErrQty);
            if (!content) return;
          } else {
            this.submitNowProductGroup(event);
          }
        },
        false
      );
    });
  }

  submitNowProductGroup(event) {
    event.preventDefault();
    const form = document.getElementById("form-product-grouped");
    const config = fetchConfig("json");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    const formData = new FormData(form);
    config.body = formData;
    fetch(`${routes.cart_add_url}.js`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        if (parsedState.items) {
          window.location.href = "/checkout";
        } else {
          const content = document.querySelector(".form-infor .add-cart-error");
          if (!content) return;
        }
      })
      .catch((e) => {
        throw e;
      });
  }

  submitProductGroup(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    const form = document.getElementById("form-product-grouped");
    const config = fetchConfig("json");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    let openMiniCart = 0;
    const formData = new FormData(form);
    if (cart) {
      formData.append(
        "sections",
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
    }
    config.body = formData;
    target.classList.add("loading");
    fetch(`${routes.cart_add_url}.js`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        fetch("/cart.json")
          .then((res) => res.json())
          .then((cart) => {
            if (cart.item_count != undefined) {
              document.querySelectorAll(".cart-count").forEach((el) => {
                if (el.classList.contains("cart-count-drawer")) {
                  el.innerHTML = `(${cart.item_count})`;
                } else {
                  el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
                }
              });
              if (document.querySelector("header-total-price")) {
                document.querySelector("header-total-price").updateTotal(cart);
              }
              const cart_free_ship = document.querySelector(
                "free-ship-progress-bar"
              );
              if (cart_free_ship) {
                cart_free_ship.init(cart.items_subtotal_price);
              }
            }
          })
          .catch((error) => {
            throw error;
          });
        const parsedState = JSON.parse(state);
        if (parsedState.message) {
          handleErrorMessagePopup(parsedState.description);
          if (!content) return;
        } else {
          parsedState.items.forEach((e) => {
            if (e.quantity > 0) {
              openMiniCart = 1;
            }
          });
          cart.getSectionsToRender().forEach((section) => {
            const elementToReplace = document.getElementById(section.id);
            const html = new DOMParser().parseFromString(
              parsedState.sections[section.id],
              "text/html"
            );
            elementToReplace.innerHTML =
              html.querySelector("#minicart-form").innerHTML;
            const countdown = cart.querySelector(".cart-countdown-time");
            const html_countdown = html.querySelector(".cart-countdown-time");
            if (countdown && html_countdown) {
              countdown.innerHTML = html_countdown.innerHTML;
            }
          });
          cart.cartAction();
        }
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        target.classList.remove("loading");
        if (openMiniCart === 1) {
          cart.open();
        }
        const cartRecommend = document.querySelector(".cart-recommend");
        if (
          cartRecommend &&
          !cartRecommend.classList.contains("hidden-recommend")
        ) {
          if (cartRecommend.classList.contains('cart-recommend-custom')) {
            const cartUpsellItem = document.querySelectorAll('.cart-upsell-item');
            const cartUpsellSlide = document.querySelectorAll('.swiper-cart-upsell .swiper-slide');
            if (cartUpsellItem.length > 0) {
              setTimeout(function () {
                cartRecommend.classList.add("open");
              }, 800);
            } else if (cartUpsellSlide.length === 0){
              cartRecommend.classList.remove('block');
              cartRecommend.classList.add('hidden');
            }
          }else{
            setTimeout(function () {
              cartRecommend.classList.add("open");
            }, 800);
          }
        }
      });
  }
}
customElements.define("product-group", ProductGrouped);

class SwatchDropdown extends HTMLElement {
  constructor() {
    super();
    this.spanFor = this.dataset.spanFor;
    this.init();
  }
  init() {
    if (!this.spanFor) return;
    this.addEventListener("click", this.activeFilterSort.bind(this), false);
  }
  activeFilterSort() {
    if (this.querySelector(`#${this.spanFor}`).classList.contains("active")) {
      this.querySelector(`#${this.spanFor}`).classList.remove("active");
    } else {
      this.querySelector(`#${this.spanFor}`).classList.add("active");
    }
  }
}
customElements.define("swatch-dropdown", SwatchDropdown);

class ProductBoughtTogether extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    const boughTogether = document.querySelector(
      '.productBoughTogether[type="application/json"]'
    );
    if (!boughTogether) return;
    const variantData = JSON.parse(boughTogether.innerText);
    let query = "";
    variantData.forEach((e, key, variantData) => {
      if (!Object.is(variantData.length - 1, key)) {
        query += e + "%20OR%20id:";
      } else {
        query += e;
      }
    });
    const productAjaxURL =
      "?q=id:" + query + "&section_id=product-bough-together";
    fetch(`${window.routes.search_url}${productAjaxURL}`)
      .then((response) => response.text())
      .then(async (responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        document.getElementById("product-bought-together").innerHTML =
          html.querySelector(".bought-together").innerHTML;
      })
      .catch((e) => {
        throw error;
      })
      .finally(() => {
        this.eventProductBoughTogetherAction();
      });
  }
  eventProductBoughTogetherAction() {
    var _this = this;
    document
      .querySelectorAll(".bought-together-checkbox")
      .forEach((checkbox) => {
        checkbox.addEventListener(
          "change",
          (event) => {
            var target = event.target;
            var total_price = 0,
              total_compare_price = 0,
              save_price = 0,
              price,
              compare_price,
              pro_handle = event.target.getAttribute("data-handle");
            var img = target
              .closest("#product-bought-together")
              .querySelector(".product-bought-image-item." + pro_handle + "");
            if (target.checked) {
              img.classList.add("select");
              target
                .closest(".product-bought-together-item")
                .classList.add("select");
              target
                .closest(".product-bought-together-item")
                .querySelector(".product-variant-option")
                .removeAttribute("disabled");
              target
                .closest(".product-bought-together-item")
                .querySelector(".quantity")
                .removeAttribute("disabled");
            } else {
              img.classList.remove("select");
              target
                .closest(".product-bought-together-item")
                .classList.remove("select");
              target
                .closest(".product-bought-together-item")
                .querySelector(".product-variant-option")
                .setAttribute("disabled", true);
              target
                .closest(".product-bought-together-item")
                .querySelector(".quantity")
                .setAttribute("disabled", true);
            }
            setTimeout(function () {
              var bought_together_select = document.querySelectorAll(
                ".product-bought-together-item.select"
              );
              bought_together_select.forEach((item) => {
                var option = item.querySelector(".product-variant-option");
                price = option.getAttribute("data-price");
                compare_price = option.getAttribute("data-compare-price");
                total_price = total_price + Number(price);
                total_compare_price =
                  total_compare_price + Number(compare_price);
              });
              save_price = total_compare_price - total_price;
              _this.eventProductBoughTogetherUpdatePrice(
                total_price,
                total_compare_price,
                save_price
              );
              if (bought_together_select.length <= 1) {
                document
                  .querySelector(".bought-together-submit")
                  .setAttribute("disabled", true);
              } else {
                document
                  .querySelector(".bought-together-submit")
                  .removeAttribute("disabled");
              }
            }, 50);
          },
          false
        );
      });
    document
      .querySelectorAll("#product-bought-together .product-variant-option")
      .forEach((select) => {
        select.addEventListener(
          "change",
          (event) => {
            var target = event.target;
            var total_price = 0,
              total_compare_price = 0,
              save_price = 0,
              image =
                target.options[target.selectedIndex].getAttribute("data-image"),
              price =
                target.options[target.selectedIndex].getAttribute("data-price"),
              pro_handle = target.getAttribute("data-handle"),
              compare_price =
                target.options[target.selectedIndex].getAttribute(
                  "data-compare-price"
                );
            var img = target
              .closest("#product-bought-together")
              .querySelector(".product-bought-image-item." + pro_handle + "")
              .querySelector("img");
            if (img) {
              img.removeAttribute("srcset");
              img.setAttribute("src", image);
            }
            const productTarget = target.closest(
              ".product-bought-together-item"
            );
            const bls__price = productTarget.querySelector(
              ".product-item__price .card-product-price"
            );
            if (bls__price) {
              if (!bls__price.querySelector(".compare-price")) {
                var ps = document.createElement("div");
                var sp = document.createElement("span");
                var cp = document.createElement("s");
                cp.classList.add("price-item", "compare-price");
                sp.appendChild(cp);
                ps.appendChild(sp);
                ps.classList.add("price-regular");
                if (productTarget.querySelector(".card-product-price")) {
                  productTarget
                    .querySelector(".card-product-price")
                    .appendChild(ps);
                }
              }
              const cpp = bls__price.querySelector(".compare-price");

              if (cpp) {
                if (compare_price && compare_price > price) {
                  const compare_format = Shopify.formatMoney(
                    compare_price,
                    themeGlobalVariables.settings.money_format
                  );
                  cpp.innerHTML = compare_format;
                  if (bls__price.querySelector(".price-regular")) {
                    bls__price
                      .querySelector(".price-regular")
                      .classList.add("primary-color");
                  }
                  if (bls__price.querySelector(".price-regular .price")) {
                    bls__price
                      .querySelector(".price-regular .price")
                      .classList.add("price--special");
                  }
                } else {
                  cpp.innerHTML = "";
                  if (bls__price.querySelector(".price-regular")) {
                    bls__price
                      .querySelector(".price-regular")
                      .classList.remove("primary-color");
                  }
                  if (bls__price.querySelector(".price-regular .price")) {
                    bls__price.querySelector(
                      ".price-regular .price"
                    ).innerHTML = Shopify.formatMoney(
                      price,
                      cartStrings.money_format
                    );
                    bls__price
                      .querySelector(".price-regular .price")
                      .classList.remove("price--special");
                  }
                }
              }
            }
            target.setAttribute("data-price", price);
            target.setAttribute("data-compare-price", compare_price);
            document
              .querySelectorAll(".product-bought-together-item.select")
              .forEach((item) => {
                var option = item.querySelector(".product-variant-option");
                price = option.getAttribute("data-price");
                compare_price = option.getAttribute("data-compare-price");
                total_price = total_price + Number(price);
                total_compare_price =
                  total_compare_price + Number(compare_price);
              });
            save_price = total_compare_price - total_price;
            _this.eventProductBoughTogetherUpdatePrice(
              total_price,
              total_compare_price,
              save_price
            );
          },
          false
        );
      });

    document.querySelectorAll(".bought-together-submit").forEach((button) => {
      button.addEventListener(
        "click",
        this.submitBoughtTogether.bind(this),
        false
      );
    });
  }
  submitBoughtTogether(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    const form = document.getElementById("bought-together-form");
    const config = fetchConfig("json");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    const formData = new FormData(form);
    if (cart) {
      formData.append(
        "sections",
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
    }
    config.body = formData;
    target.classList.add("loading");
    fetch(`${routes.cart_add_url}.js`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        fetch("/cart.json")
          .then((res) => res.json())
          .then((cart) => {
            if (cart.item_count != undefined) {
              document.querySelectorAll(".cart-count").forEach((el) => {
                if (el.classList.contains("cart-count-drawer")) {
                  el.innerHTML = `(${cart.item_count})`;
                } else {
                  el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
                }
              });
              if (document.querySelector("header-total-price")) {
                document.querySelector("header-total-price").updateTotal(cart);
              }
              const cart_free_ship = document.querySelector(
                "free-ship-progress-bar"
              );
              if (cart_free_ship) {
                cart_free_ship.init(cart.items_subtotal_price);
              }
            }
          })
          .catch((error) => {
            throw error;
          });
        const parsedState = JSON.parse(state);
        cart.getSectionsToRender().forEach((section) => {
          const elementToReplace = document.getElementById(section.id);
          const html = new DOMParser().parseFromString(
            parsedState.sections[section.id],
            "text/html"
          );
          elementToReplace.innerHTML =
            html.querySelector("#minicart-form").innerHTML;
          const countdown = cart.querySelector(".cart-countdown-time");
          const html_countdown = html.querySelector(".cart-countdown-time");
          if (countdown && html_countdown) {
            countdown.innerHTML = html_countdown.innerHTML;
          }
        });
        cart.cartAction();
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        target.classList.remove("loading");
        cart.open();
        const cartRecommend = document.querySelector(".cart-recommend");
        if (
          cartRecommend &&
          !cartRecommend.classList.contains("hidden-recommend")
        ) {
          if (cartRecommend.classList.contains('cart-recommend-custom')) {
            const cartUpsellItem = document.querySelectorAll('.cart-upsell-item');
            const cartUpsellSlide = document.querySelectorAll('.swiper-cart-upsell .swiper-slide');
            if (cartUpsellItem.length > 0) {
              setTimeout(function () {
                cartRecommend.classList.add("open");
              }, 800);
            } else if (cartUpsellSlide.length === 0){
              cartRecommend.classList.remove('block');
              cartRecommend.classList.add('hidden');
            }
          }else{
            setTimeout(function () {
              cartRecommend.classList.add("open");
            }, 800);
          }
        }
      });
  }

  eventProductBoughTogetherUpdatePrice(
    total_price,
    total_compare_price,
    save_price
  ) {
    var total = document.querySelector("#product-bought-together .box-total");
    if (total) {
      total.querySelector(".saved-price .price").innerHTML =
        Shopify.formatMoney(save_price, cartStrings.money_format);
      total.querySelector(".total-price .price__sale .price-item").innerHTML =
        Shopify.formatMoney(total_compare_price, cartStrings.money_format);
      total.querySelector(".total-price .price").innerHTML =
        Shopify.formatMoney(total_price, cartStrings.money_format);
      if (total_compare_price > total_price) {
        total.querySelector(".total-price").classList.add("price--on-sale");
        total
          .querySelector(".total-price .price")
          .classList.add("special-price");
      } else {
        total.querySelector(".total-price").classList.remove("price--on-sale");
        total
          .querySelector(".total-price .price")
          .classList.remove("special-price");
      }
      if (save_price > 1) {
        total.querySelector(".saved-price").classList.remove("hidden");
      } else {
        total.querySelector(".saved-price").classList.add("hidden");
      }
    }
  }
}
customElements.define("product-bought-together", ProductBoughtTogether);

document.addEventListener("DOMContentLoaded", function () {
  function addProductEntry(productJson, storedProducts) {
    if (storedProducts === null) storedProducts = [];

    var currentProductID = productJson.id.toString();
    if (!storedProducts.includes(currentProductID)) {
      storedProducts.unshift(currentProductID);
      if (storedProducts.length > 25) {
        storedProducts.pop();
      }
      localStorage.setItem(
        "glozin__recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    } else {
      const index = storedProducts.indexOf(currentProductID);
      if (index > -1) {
        storedProducts.splice(index, 1);
      }
      storedProducts.unshift(currentProductID);
      localStorage.setItem(
        "glozin__recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    }
  }

  const prodData = document.querySelector("[data-product-json]");
  if (prodData != null) {
    var productJson = JSON.parse(prodData.innerHTML);
    var storedProducts = JSON.parse(
      localStorage.getItem("glozin__recently-viewed-products")
    );
    addProductEntry(productJson, storedProducts);
  }
});
var BlsDropDownProduct = (function () {
  return {
    innit: function () {
      var custom_select = document.querySelectorAll(".custom-select");
      if (custom_select) {
        custom_select.forEach((item) => {
          let select__selected = item.querySelector(".select__selected");
          select__selected.addEventListener("click", (e) => {
            let dropdown = e.target.nextElementSibling;
            dropdown.classList.toggle("hidden");
          });
        });
      }
      document.addEventListener("click", function (event) {
        if (!event.target.closest(".custom-select")) {
          document.querySelectorAll(".select__dropdown")?.forEach((item) => {
            item.classList.add("hidden");
          });
        }
      });
    },
  };
})();

BlsDropDownProduct.innit();

var SyncQuantityInput = (() => {
  return {
    init: () => {
      const syncInputs = document.querySelectorAll(
        ".product-detail__buy-buttons input.quantity-input"
      );
      syncInputs.forEach((input) => {
        input.addEventListener("change", function () {
          const value = this.value;
          syncInputs.forEach((otherInput) => {
            if (otherInput !== input) {
              otherInput.value = value;
            }
          });
        });
      });
    },
  };
})();

SyncQuantityInput.init();

class SlideSectionProductSet extends HTMLElement {
  constructor() {
    super();
    this.globalSlide = null;
    this.init();
  }

  init() {
    if (document.body.classList.contains("index")) {
      let pos = window.pageYOffset;
      if (pos > 0 || document.body.classList.contains("swiper-lazy")) {
        this.initSlide();
      } else {
        if (this.classList.contains("lazy-loading-swiper-before")) {
          this.initSlide();
        } else {
          this.classList.add("lazy-loading-swiper-after");
        }
      }
    } else {
      this.initSlide();
    }
  }

  initSlide() {
    const _this = this;
    var autoplaying = _this?.dataset.autoplay === "true";
    const loop = _this?.dataset.loop === "true";
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : "";
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
    const direction = _this?.dataset.direction
      ? _this?.dataset.direction
      : "horizontal";
    var autoplaySpeed = _this?.dataset.autoplaySpeed
      ? _this?.dataset.autoplaySpeed * 1000
      : 3000;
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
    const effect = _this?.dataset.effect ? _this?.dataset.effect : "slide";
    const row = _this?.dataset.row ? _this?.dataset.row : 1;
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
    const autoItem = _this?.dataset.itemMobile === "true";
    const arrowCenterimage = _this?.dataset.arrowCenterimage
      ? _this?.dataset.arrowCenterimage
      : 0;
    spacing = Number(spacing);
    autoplaySpeed = Number(autoplaySpeed);
    speed = Number(speed);
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1;
      } else if (itemDesktop < 3) {
        itemTablet = 2;
      } else {
        itemTablet = 3;
      }
    }
    this.globalSlide = new Swiper(_this, {
      slidesPerView: autoItem ? "auto" : itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: loop,
      effect: effect,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      grid: {
        rows: row,
        fill: "row",
      },
      navigation: {
        nextEl: _this.querySelector(".swiper-button-next"),
        prevEl: _this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        clickable: true,
        el: document.querySelector(".swiper-pagination-product-set"),
        type: "custom",
        renderCustom: function (swiper, current, total) {
          return current + "/" + total;
        }
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
        },
      },

      on: {
        init: function () {
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll(
              ".product-item__media--ratio"
            );
            if (items_slide.length != 0) {
              var oH = [];
              items_slide.forEach((e) => {
                oH.push(e.offsetHeight / 2);
              });
              var max = Math.max(...oH);
              var arrowsOffset = "--arrows-offset-top: " + max + "px";
              if (_this.querySelectorAll(".swiper-arrow")) {
                _this.querySelectorAll(".swiper-arrow").forEach((arrow) => {
                  arrow.setAttribute("style", arrowsOffset);
                });
              }
            }
          }
        }
      },
    });
  }
}
customElements.define("slide-section-product-set", SlideSectionProductSet);

// 产品切换器类
class ProductSwitcher extends HTMLElement {
  constructor() {
    super()
    this.productData = {}
    this.currentProductId = null
    this.productIds = []
    this.init()
  }

  /**
   * 根据产品 URL 显示/隐藏特定元素
   * @param {string} productUrl - 产品 URL
   */
  toggleTargetDiv(productUrl) {
    const selector = ".custom-liquid-block"
    const maxDuration = 5000 // 5秒
    const interval = 100 // 每100ms查询一次
    const startTime = Date.now()
    
    const tryToggle = () => {
      const targetDiv = document.querySelector(selector)
      
      if (targetDiv) {
        if (productUrl === "/products/dji-mavic-4-pro") {
          targetDiv.style.display = "none"
        } else {
          targetDiv.style.display = ""
        }
        return true // 找到了，停止查询
      }
      
      // 检查是否超过5秒
      if (Date.now() - startTime >= maxDuration) {
        return false // 超时，停止查询
      }
      
      return null // 继续查询
    }
    
    // 立即尝试一次
    if (tryToggle() !== null) {
      return
    }
    
    // 如果没找到，使用定时器继续查询
    const timer = setInterval(() => {
      const result = tryToggle()
      if (result !== null) {
        clearInterval(timer)
      }
    }, interval)
    
    // 设置超时清理定时器
    setTimeout(() => {
      clearInterval(timer)
    }, maxDuration)
  }

  init() {
    // 从页面中获取所有产品数据（已通过 Liquid 预渲染）
    const dataScript = this.querySelector(".productSwitcherData")
    if (!dataScript) {
      console.warn("产品切换器数据未找到")
      return
    }

    try {
      const data = JSON.parse(dataScript.textContent)
      this.currentProductId = parseInt(data.currentProductId)
      this.productIds = []

      // 将所有产品数据加载到内存中
      if (data.products && Array.isArray(data.products)) {
        data.products.forEach((product) => {
          this.productData[product.id] = product
          this.productIds.push(product.id)
        })
      }

      console.log("产品切换器初始化完成，产品数量:", this.productIds.length)

      // 设置事件监听器
      this.setupEventListeners()
      this.setActiveProduct(this.currentProductId)
      
      // 检查初始产品 URL，隐藏/显示特定元素
      const currentProduct = this.productData[this.currentProductId]
      if (currentProduct && currentProduct.url) {
        this.toggleTargetDiv(currentProduct.url)
      }
    } catch (error) {
      console.error("产品切换器初始化失败:", error)
    }

    const list = this.querySelector(".product-switcher__list")
    if (!list) {
      console.warn("产品切换器列表元素未找到")
      return
    }

    console.log("开始渲染产品切换器，产品ID列表:", this.productIds)
    console.log("已加载的产品数据:", Object.keys(this.productData))
    console.log("当前产品ID:", this.currentProductId)

    // 获取所有已存在的产品项（包括当前产品）
    const allExistingItems = list.querySelectorAll(".product-switcher__item")
    const existingItemIds = Array.from(allExistingItems).map(item => parseInt(item.dataset.productId))

    // 移除不在产品ID列表中的项（保留当前产品）
    allExistingItems.forEach((item) => {
      const itemId = parseInt(item.dataset.productId)
      if (itemId !== this.currentProductId && !this.productIds.includes(itemId)) {
        item.remove()
      }
    })

    // 添加所有缺失的产品
    let renderedCount = 0

    this.productIds.forEach((productId) => {
      // 跳过当前产品，因为它已经在HTML中渲染了
      if (productId === this.currentProductId) {
        console.log(`跳过当前产品 ${productId}，已在HTML中`)
        return
      }

      // 如果这个产品已经存在，检查是否需要更新
      if (existingItemIds.includes(productId)) {
        const existingItem = list.querySelector(`[data-product-id="${productId}"]`)
        const product = this.productData[productId]

        // 如果数据已加载但项还是占位符，更新它
        if (product && existingItem && existingItem.querySelector(".product-switcher__title")?.textContent === "加载中...") {
          console.log(`更新产品 ${productId} 的占位符`)
          this.updateProductItem(existingItem, product)
        } else {
          console.log(`产品 ${productId} 已存在且已更新，跳过`)
        }
        return
      }

      const product = this.productData[productId]
      if (!product) {
        console.warn(`产品 ${productId} 的数据未加载，创建占位符`)
        // 即使数据未加载，也创建一个占位符
        const placeholderItem = document.createElement("div")
        placeholderItem.className = `product-switcher__item flex flex-col gap-10 p-15 border rounded-5 cursor-pointer transition border-gray`
        placeholderItem.dataset.productId = productId
        placeholderItem.dataset.productHandle = ""
        placeholderItem.dataset.productUrl = ""
        placeholderItem.tabIndex = 0
        placeholderItem.setAttribute("role", "button")
        placeholderItem.setAttribute("aria-label", `Product ${productId}`)
        placeholderItem.innerHTML = `
          <div class="product-switcher__image relative overflow-hidden rounded-5" style="--aspect-ratio: 1/1; width: 100px; background: #f0f0f0; display: flex; align-items: center; justify-content: center;">
            <span style="color: #999; font-size: 12px;">加载中...</span>
          </div>
          <div class="product-switcher__info flex flex-col gap-5">
            <h3 class="product-switcher__title text-size heading-style mb-0">加载中...</h3>
            <div class="product-switcher__price">
              <span class="price-item price text-size heading-style">-</span>
            </div>
          </div>
        `
        list.appendChild(placeholderItem)
        renderedCount++
        return
      }

      const firstVariant = product.variants?.[0] || product.selected_or_first_available_variant
      let productImage = product.featured_image || firstVariant?.featured_image

      // 如果 productImage 是对象，尝试获取图片 URL
      if (productImage && typeof productImage === "object") {
        if (productImage.preview_image) {
          productImage = productImage.preview_image.src || productImage.preview_image
        } else if (productImage.src) {
          productImage = productImage.src
        } else if (productImage.url) {
          productImage = productImage.url
        }
      }

      // 如果还是没有图片，尝试从媒体数组中获取第一张
      if (!productImage && product.media && product.media.length > 0) {
        const firstMedia = product.media[0]
        if (firstMedia.preview_image) {
          productImage = firstMedia.preview_image.src || firstMedia.preview_image
        }
      }

      // 创建新的产品项
      const item = this.createProductItem(productId, product)
      list.appendChild(item)
      renderedCount++
    })

    console.log(`产品切换器渲染完成，共新增 ${renderedCount} 个产品`)
    const totalItems = list.querySelectorAll('.product-switcher__item').length
    console.log(`应该显示 ${this.productIds.length} 个产品，当前显示 ${totalItems} 个`)

    // 如果渲染的产品数量不对，输出详细信息
    if (totalItems !== this.productIds.length) {
      console.error("产品数量不匹配！")
      console.log("产品ID列表:", this.productIds)
      console.log("已加载的产品:", Object.keys(this.productData))
      const renderedIds = Array.from(list.querySelectorAll('.product-switcher__item')).map(item => parseInt(item.dataset.productId))
      console.log("已渲染的产品ID:", renderedIds)
      const missingIds = this.productIds.filter(id => !renderedIds.includes(id))
      console.log("缺失的产品ID:", missingIds)
    }
  }

  createProductItem(productId, product) {
    const firstVariant = product.variants?.[0] || product.selected_or_first_available_variant
    let productImage = product.featured_image || firstVariant?.featured_image

    // 如果 productImage 是对象，尝试获取图片 URL
    if (productImage && typeof productImage === "object") {
      if (productImage.preview_image) {
        productImage = productImage.preview_image.src || productImage.preview_image
      } else if (productImage.src) {
        productImage = productImage.src
      } else if (productImage.url) {
        productImage = productImage.url
      }
    }

    // 如果还是没有图片，尝试从媒体数组中获取第一张
    if (!productImage && product.media && product.media.length > 0) {
      const firstMedia = product.media[0]
      if (firstMedia.preview_image) {
        productImage = firstMedia.preview_image.src || firstMedia.preview_image
      }
    }

    const price = firstVariant?.price || product.price || 0
    const comparePrice = firstVariant?.compare_at_price || product.compare_at_price || 0
    const discountAmount = comparePrice > price ? comparePrice - price : 0
    const discountPercentage = comparePrice > price && comparePrice > 0
      ? Math.floor((discountAmount / comparePrice) * 100)
      : 0

    const item = document.createElement("div")
    item.className = `product-switcher__item flex items-center gap-15 p-15 border-2 rounded-5 cursor-pointer transition border-gray`
    item.dataset.productId = productId
    item.dataset.productHandle = product.handle || ""
    item.dataset.productUrl = product.url || `/products/${product.handle || productId}`

    item.tabIndex = 0
    item.setAttribute("role", "button")
    item.setAttribute("aria-label", product.title || `Product ${productId}`)

    let imageHTML = ""
    if (productImage && typeof productImage === "string") {
      imageHTML = `
        <div class="product-switcher__image relative overflow-hidden rounded-5 flex-shrink-0" style="width: 80px; height: 80px;">
          <img
            src="${productImage}"
            alt="${product.title || ""}"
            width="80"
            height="80"
            loading="lazy"
            class="w-full h-full object-cover"
          >
        </div>
      `
    }

    let discountHTML = ""
    if (discountPercentage > 0) {
      discountHTML = `
        <div class="product-switcher__discount inline-block bg-orange-500 text-white px-8 py-3 rounded-3 text-xs font-bold">
          Save ${discountPercentage}%
        </div>
      `
    }

    let priceHTML = ""
    if (comparePrice > price) {
      priceHTML = `
        <span class="price-item compare-price text-xs text-gray-500">
          <s>${this.formatMoney(comparePrice)}</s>
        </span>
      `
    }
    priceHTML += `
      <span class="price-item price text-base heading-style font-bold">
        ${this.formatMoney(price)}
      </span>
    `

    item.innerHTML = `
      ${imageHTML}
      <div class="product-switcher__info flex items-center justify-between flex-1 gap-15">
        <div class="product-switcher__content flex flex-col gap-5 flex-1">
          <h3 class="product-switcher__title text-sm heading-style mb-0">
            ${product.title || `Product ${productId}`}
          </h3>
          ${discountHTML}
        </div>
        <div class="product-switcher__price flex flex-col items-end gap-5 flex-shrink-0">
          ${priceHTML}
        </div>
      </div>
    `

    return item
  }

  updateProductItem(item, product) {
    const firstVariant = product.variants?.[0] || product.selected_or_first_available_variant
    let productImage = product.featured_image || firstVariant?.featured_image

    if (productImage && typeof productImage === "object") {
      if (productImage.preview_image) {
        productImage = productImage.preview_image.src || productImage.preview_image
      } else if (productImage.src) {
        productImage = productImage.src
      }
    }

    if (!productImage && product.media && product.media.length > 0) {
      const firstMedia = product.media[0]
      if (firstMedia.preview_image) {
        productImage = firstMedia.preview_image.src || firstMedia.preview_image
      }
    }

    const price = firstVariant?.price || product.price || 0
    const comparePrice = firstVariant?.compare_at_price || product.compare_at_price || 0
    const discountAmount = comparePrice > price ? comparePrice - price : 0

    // 更新属性
    item.dataset.productHandle = product.handle || ""
    const productUrl = product.url || `/products/${product.handle || product.id}`
    item.dataset.productUrl = productUrl
    item.setAttribute("aria-label", product.title || `Product ${product.id}`)
    
    // 根据产品 URL 显示/隐藏特定元素（仅在当前激活的产品时）
    if (parseInt(item.dataset.productId) === this.currentProductId && productUrl) {
      this.toggleTargetDiv(productUrl)
    }

    // 更新图片
    const imageContainer = item.querySelector(".product-switcher__image")
    if (imageContainer && productImage && typeof productImage === "string") {
      imageContainer.innerHTML = `
        <img
          src="${productImage}"
          alt="${product.title || ""}"
          width="80"
          height="80"
          loading="lazy"
          class="w-full h-full object-cover"
        >
      `
    } else if (!imageContainer && productImage && typeof productImage === "string") {
      // 如果图片容器不存在，创建它
      const imageDiv = document.createElement("div")
      imageDiv.className = "product-switcher__image relative overflow-hidden rounded-5 flex-shrink-0"
      imageDiv.style.width = "80px"
      imageDiv.style.height = "80px"
      imageDiv.innerHTML = `
        <img
          src="${productImage}"
          alt="${product.title || ""}"
          width="80"
          height="80"
          loading="lazy"
          class="w-full h-full object-cover"
        >
      `
      item.insertBefore(imageDiv, item.firstChild)
    }

    // 更新内容区域
    let contentContainer = item.querySelector(".product-switcher__content")
    if (!contentContainer) {
      const infoContainer = item.querySelector(".product-switcher__info")
      if (infoContainer) {
        contentContainer = document.createElement("div")
        contentContainer.className = "product-switcher__content flex flex-col gap-5 flex-1"
        infoContainer.insertBefore(contentContainer, infoContainer.firstChild)
      }
    }

    // 更新标题
    if (contentContainer) {
      let titleElement = contentContainer.querySelector(".product-switcher__title")
      if (!titleElement) {
        titleElement = document.createElement("h3")
        titleElement.className = "product-switcher__title text-sm heading-style mb-0"
        contentContainer.appendChild(titleElement)
      }
      titleElement.textContent = product.title || `Product ${product.id}`

      // 更新折扣标签
      let discountElement = contentContainer.querySelector(".product-switcher__discount")
      if (discountAmount > 0) {
        if (!discountElement) {
          discountElement = document.createElement("div")
          discountElement.className = "product-switcher__discount inline-block bg-orange-500 text-white px-8 py-3 rounded-3 text-xs font-bold"
          contentContainer.appendChild(discountElement)
        }
        discountElement.textContent = `${this.formatMoney(discountAmount)} OFF`
      } else if (discountElement) {
        discountElement.remove()
      }
    }

    // 更新价格
    let priceContainer = item.querySelector(".product-switcher__price")
    if (!priceContainer) {
      const infoContainer = item.querySelector(".product-switcher__info")
      if (infoContainer) {
        priceContainer = document.createElement("div")
        priceContainer.className = "product-switcher__price flex flex-col items-end gap-5 flex-shrink-0"
        infoContainer.appendChild(priceContainer)
      }
    }

    if (priceContainer) {
      let priceHTML = ""
      priceHTML += `
        <span class="price-item price text-base heading-style font-bold">
          ${this.formatMoney(price)}
        </span>
      `

      if (comparePrice > price) {
        priceHTML = `
          <span class="price-item compare-price text-xs text-gray-500">
            <s>${this.formatMoney(comparePrice)}</s>
          </span>
        `
      }

      priceContainer.innerHTML = priceHTML
    }
  }

  setupEventListeners() {
    const items = this.querySelectorAll(".product-switcher__item")
    items.forEach((item) => {
      item.addEventListener("click", this.handleProductSwitch.bind(this))
      item.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault()
          this.handleProductSwitch({ currentTarget: item })
        }
      })
    })
  }

  handleProductSwitch(e) {
    const item = e.currentTarget
    const productId = parseInt(item.dataset.productId)

    if (productId === this.currentProductId) return

    this.currentProductId = productId
    this.setActiveProduct(productId)
    this.updateProductContent(productId)
  }

  setActiveProduct(productId) {
    const items = this.querySelectorAll(".product-switcher__item")
    items.forEach((item) => {
      if (parseInt(item.dataset.productId) === productId) {
        item.classList.add("active", "border-primary")
        item.classList.remove("border-gray")
      } else {
        item.classList.remove("active", "border-primary")
        item.classList.add("border-gray")
      }
    })
  }

  async updateProductContent(productId) {
    const product = this.productData[productId]
    if (!product) {
      console.warn(`产品 ${productId} 数据不存在`)
      return
    }

    // 更新媒体画廊
    await this.updateMediaGallery(product)

    // 更新产品描述
    this.updateProductDescription(product)

    // 更新产品信息（价格、变体等）
    this.updateProductInfo(product)

    // 更新配件列表
    this.updateAccessoriesList(product)

    // 更新推荐配件列表
    this.updateRecommendedAccessories(product)

    // 更新 URL（可选）
    if (this.dataset.updateUrl !== "false" && product.url) {
      window.history.pushState({}, "", product.url)
    }

    // 根据产品 URL 显示/隐藏特定元素
    if (product.url) {
      this.toggleTargetDiv(product.url)
    }

    // 更新 parcelpanel_widget 产品数据
    if (window.parcelpanel_widget && typeof window.parcelpanel_widget === "object") {
      product.available = !!product.variants.find(variant => variant.available)
      window.parcelpanel_widget.product = product

      // 调用 refresh 方法
      if (typeof window.parcelpanel_widget.refresh === "function") {
        window.parcelpanel_widget.refresh()
      }
    }
  }

  formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return Shopify.formatMoney(
        cents,
        themeGlobalVariables?.settings?.money_format || "{{amount}}"
      )
    }
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(cents / 100)
  }

  async updateMediaGallery(product) {
    const mediaGallery = document.querySelector("media-gallery")
    if (!mediaGallery) return

    const layout = mediaGallery.dataset.layout
    const sectionId = this.dataset.section

    // 使用产品数据中的媒体（已通过 Liquid 预加载）
    const media = product.media
    if (!media || media.length === 0) {
      console.warn("产品没有媒体数据")
      return
    }

    if (layout === "thumbnail") {
      // 更新缩略图布局的媒体
      await this.updateThumbnailMedia(product, mediaGallery, sectionId)
    } else if (layout === "grid" || layout === "stack") {
      // 更新网格或堆叠布局的媒体
      await this.updateGridMedia(product, mediaGallery, sectionId)
    }
  }

  async updateThumbnailMedia(product, mediaGallery, sectionId) {

    const swiper = mediaGallery.querySelector("slide-with-thumbs")
    if (!swiper) return

    const mainWrapper = swiper.querySelector(".media-main-swiper .swiper-wrapper")
    const thumbWrapper = swiper.querySelector(".thumbnail-slide .swiper-wrapper")

    if (!mainWrapper || !product.media || product.media.length === 0) return

    // 清空现有内容
    mainWrapper.innerHTML = ""
    if (thumbWrapper) {
      thumbWrapper.innerHTML = ""
    }

    // 创建新的媒体项
    const mediaItems = product.media.map((media, index) => {
      return this.createMediaItem(media, sectionId, index === 0)
    }).filter(item => item.mainHTML) // 过滤掉无效项

    // 添加到主画廊
    mediaItems.forEach((item) => {
      const mainSlide = document.createElement("div")
      mainSlide.className = "swiper-slide media-item"
      mainSlide.innerHTML = item.mainHTML
      mainWrapper.appendChild(mainSlide)

      // 添加到缩略图
      if (thumbWrapper && item.thumbHTML) {
        const thumbSlide = document.createElement("div")
        // 注意：swiper-slide-thumb-active 会加在 .swiper-slide 上
        // CSS 选择器是：.thumbnail-slide [class*="media-gallery__"].swiper-slide-thumb-active:after
        // 所以这里必须让 swiper-slide 本身包含 media-gallery__ 前缀的 class
        thumbSlide.className = "swiper-slide media-gallery__thumbnail rounded-5 pointer"
        thumbSlide.innerHTML = item.thumbHTML
        thumbWrapper.appendChild(thumbSlide)
      }
    })

    // 重新初始化 Swiper
    if (swiper.functionInit) {
      swiper.functionInit()
    } else if (window.Swiper) {
      // 如果 Swiper 已经初始化，需要销毁并重新初始化
      const swiperInstance = swiper.swiper
      if (swiperInstance) {
        swiperInstance.destroy(true, true)
      }
      // 触发自定义事件让 slide-with-thumbs 重新初始化
      swiper.dispatchEvent(new CustomEvent("swiper-update"))
    }

    // 切换产品后：强制回到第一张图（主图 + 缩略图）
    const resetToFirstSlide = () => {
      // 主题里 SlideWithThumbs 会把实例挂在元素上：this.globalSlide / this.thumbnailSlide
      // 并提供 functionGoto(position) 方法
      if (typeof swiper.functionGoto === "function") {
        swiper.functionGoto(0)
      }

      if (swiper.thumbnailSlide && typeof swiper.thumbnailSlide.slideTo === "function") {
        swiper.thumbnailSlide.slideTo(0, 0)
      }

      if (swiper.globalSlide && typeof swiper.globalSlide.update === "function") {
        swiper.globalSlide.update()
      }

      if (swiper.thumbnailSlide && typeof swiper.thumbnailSlide.update === "function") {
        swiper.thumbnailSlide.update()
      }
    }

    // 等待 slide-with-thumbs / Swiper 初始化完成（有时会异步）
    const waitForSwiperAndReset = (attempt = 0) => {
      if (attempt > 15) return

      const hasInstances = Boolean(swiper.globalSlide && swiper.thumbnailSlide)
      if (hasInstances) {
        resetToFirstSlide()
        return
      }

      window.setTimeout(() => {
        waitForSwiperAndReset(attempt + 1)
      }, 50)
    }

    waitForSwiperAndReset()
  }

  async updateGridMedia(product, mediaGallery, sectionId) {
    const galleryContainer = mediaGallery.querySelector(
      "#GalleryViewer-" + sectionId
    )
    if (!galleryContainer) return

    galleryContainer.innerHTML = ""

    product.media.forEach((media, index) => {
      const item = this.createMediaItem(media, sectionId, index === 0)
      const mediaElement = document.createElement("div")
      mediaElement.innerHTML = item.mainHTML
      galleryContainer.appendChild(mediaElement.firstElementChild)
    })

    // 重新初始化懒加载
    if (window.BlsLazyloadImg && window.BlsLazyloadImg.init) {
      window.BlsLazyloadImg.init()
    }
  }

  createMediaItem(media, sectionId, isFirst) {
    const mediaId = `${sectionId}-${media.id}`
    let imageUrl, imageAlt, aspectRatio, width, height

    if (typeof media === "object" && media.preview_image) {
      imageUrl = media.preview_image.src || media.preview_image
      imageAlt = media.alt || "product"
      width = media.preview_image.width || 1200
      height = media.preview_image.height || 1200
      aspectRatio = width / height
    } else if (typeof media === "string") {
      imageUrl = media
      imageAlt = "product"
      aspectRatio = 1
      width = 1200
      height = 1200
    } else {
      return { mainHTML: "", thumbHTML: "" }
    }

    // 注意：Photoswipe / 主题脚本会 querySelectorAll('a.media-gallery__image')
    // 所以这里必须用 <a>，并保持 media-gallery__image-link 结构
    const mainHTML = `
      <div
        class="media-gallery__image rounded-5 pointer"
        href="${imageUrl}"
        data-position="${media.position}"
        data-media-id="${mediaId}"
        data-pswp-width="${width}"
        data-pswp-height="${height}"
        data-alt="${imageAlt}"
        data-media="${media.id}"
        style="--aspect-ratio: ${aspectRatio}"
      >
        <span
          class="media-gallery__image-link"
          data-position="${media.position}"
          data-pswp-width="${width}"
          data-pswp-height="${height}"
          data-cropped="true"
        >
          <img
            src="${imageUrl}"
            alt="${imageAlt}"
            width="${width}"
            height="${height}"
            loading="${isFirst ? "eager" : "lazy"}"
            class="w-full h-full object-cover"
          >
        </span>
      </div>
    `

    // 注意：thumb 的 root class 要放到 swiper-slide 上（见 updateThumbnailMedia）
    const thumbHTML = `
      <img
        src="${imageUrl}"
        alt="${imageAlt}"
        width="100"
        height="100"
        loading="lazy"
        class="w-full h-full object-cover"
      >
    `

    return { mainHTML, thumbHTML }
  }

  updateProductDescription(product) {
    // 更新产品描述
    const descriptionBlocks = document.querySelectorAll(
      ".product-single__description, .product_detail-des, .product-single__short-description"
    )

    document.querySelector(".delivery-content-more").innerHTML = product.description

    descriptionBlocks.forEach((block) => {
      if (product.metafields?.custom?.short_description) {
        block.innerHTML = product.metafields.custom.short_description
      } else if (product.short_description) {
        block.innerHTML = product.short_description
      } else if (product.description) {
        block.innerHTML = product.description
      }
    })

    // 更新产品标题（如果需要）
    const titleElement = document.querySelector(".product-detail__title h1, h1.product-detail__title")
    if (titleElement && product.title) {
      titleElement.textContent = product.title
    }
  }

  updateProductInfo(product) {
    // 更新产品价格
    const firstVariant = product.variants?.[0] || product.selected_or_first_available_variant
    if (firstVariant) {
      const price = firstVariant.price || product.price || 0
      const comparePrice = firstVariant.compare_at_price || product.compare_at_price || 0

      // 找到价格容器
      const priceContainer = document.querySelector(".product-detail__price")
      if (!priceContainer) return

      // 找到或创建 card-product-price 容器
      let cardPriceContainer = priceContainer.querySelector(".card-product-price")
      if (!cardPriceContainer) {
        cardPriceContainer = document.createElement("div")
        cardPriceContainer.className = "card-product-price price-large flex align-center flex-wrap gap-5 relative"
        priceContainer.insertBefore(cardPriceContainer, priceContainer.firstChild)
      }

      const hasDiscount = comparePrice > price

      if (hasDiscount) {
        // 有折扣价的情况
        cardPriceContainer.innerHTML = `
          <div class="price-regular primary-color">
            <span class="visually-hidden">Sale price</span>
            <span class="price heading_weight primary-color price-same-style price--special">
              ${this.formatMoney(price)}
            </span>
          </div>
          <div class="price-regular">
            <span class="visually-hidden">Regular price</span>
            <s class="price-item compare-price dark-grey">${this.formatMoney(comparePrice)}</s>
          </div>
        `

        // 有折扣时显示或创建 save tag
        let saveTag = priceContainer.querySelector(".product-save-tag")
        const saveAmount = comparePrice - price

        if (!saveTag) {
          // 如果不存在，创建 save tag
          saveTag = document.createElement("span")
          saveTag.className = "product-save-tag"
          // 使用默认样式（与 liquid 模板中的默认值一致）
          saveTag.style.cssText = "background-color: #ff9505; color: #ffffff; padding: 4px 8px; border-radius: 4px; margin-left: 8px; font-size: 14px; font-weight: normal;"
          priceContainer.appendChild(saveTag)
        }
        saveTag.textContent = `Save ${this.formatMoney(saveAmount)}`
        saveTag.style.display = ""
      } else {
        // 没有折扣价的情况
        cardPriceContainer.innerHTML = `
          <div class="price-regular">
            <span class="visually-hidden">Regular price</span>
            <span class="price price-same-style heading-style">
              ${this.formatMoney(price)}
            </span>
          </div>
        `

        // 没有折扣时移除 save tag
        const saveTag = priceContainer.querySelector(".product-save-tag")
        if (saveTag) {
          saveTag.remove()
        }
      }
    }

    // 更新变体 ID 和购买按钮
    if (firstVariant) {
      const variantId = firstVariant.id
      const sectionId = this.dataset.section

      // 更新所有产品表单中的变体 ID（包括主表单和 sticky 表单）
      const productFormIds = [
        `product-form-${sectionId}`,
        `sticky-addcart-form-${sectionId}`
      ]

      productFormIds.forEach((formId) => {
        const productForm = document.getElementById(formId)
        if (productForm) {
          // 更新变体 ID 输入框
          const variantInput = productForm.querySelector('input[name="id"]')
          if (variantInput) {
            variantInput.value = variantId
            // 触发 change 事件，让其他组件能够响应变体变化
            variantInput.dispatchEvent(new Event("change", { bubbles: true }))
          }

          // 更新按钮的可用状态
          const submitButton = productForm.querySelector('.product-form__submit, button[type="submit"]')
          if (submitButton) {
            if (firstVariant.available === false) {
              submitButton.disabled = true
              const btnLabel = submitButton.querySelector('.btn-label')
              if (btnLabel) {
                btnLabel.textContent = submitButton.dataset.outstockText || 'Out of stock'
              }
            } else {
              submitButton.disabled = false
              const btnLabel = submitButton.querySelector('.btn-label')
              if (btnLabel) {
                btnLabel.textContent = submitButton.dataset.addToCartText || 'Add to cart'
              }
            }
          }
        }
      })

      // 也更新所有类名为 product-variant-id 的输入框
      const allVariantInputs = document.querySelectorAll('input.product-variant-id, input[name="id"]')
      allVariantInputs.forEach((input) => {
        if (input.form && (input.form.id === `product-form-${sectionId}` || input.form.id === `sticky-addcart-form-${sectionId}`)) {
          input.value = variantId
          input.dispatchEvent(new Event("change", { bubbles: true }))
        }
      })

      // 更新 gift card recipient form 的变体 ID（如果有）
      const giftCardForm = document.querySelector(`[data-product-variant-id]`)
      if (giftCardForm) {
        giftCardForm.dataset.productVariantId = variantId
      }
    }

    // 更新产品 JSON 数据
    const productJsonScript = document.querySelector('[data-product-json]')
    if (productJsonScript) {
      productJsonScript.textContent = JSON.stringify(product)
    }

    // 触发变体变化事件，让其他组件能够响应
    if (firstVariant && window.PUB_SUB_EVENTS) {
      window.PUB_SUB_EVENTS.publish('variantChange', {
        sectionId: this.dataset.section,
        variant: firstVariant
      })
    }
  }

  updateAccessoriesList(product) {
    // 查找所有配件 section
    const accessoriesSections = document.querySelectorAll(".in-the-box-section")
    if (!accessoriesSections || accessoriesSections.length === 0) return

    // 获取配件数据 - 使用两个独立的数组
    const images = product.accessories_images || []
    const texts = product.accessories_texts || []

    // 如果数据不存在，直接返回
    if (!images || images.length === 0) {
      document.querySelector(".desktop-accessories-list").innerHTML = "<p style='text-align: center;width: 100%' class='text-center w-full'>No accessories available.</p>"
      document.querySelector(".mobile-accessories-list").innerHTML = "<p style='text-align: center;width: 100%' class='text-center w-full'>No accessories available.</p>"
      return
    }

    accessoriesSections.forEach((section) => {
      const desktopList = section.querySelector(".desktop-accessories-list .accessories-list")
      const mobileList = section.querySelector(".mobile-accessories-list .accessories-list")

      if (!desktopList || !mobileList) return

      // 获取 section 设置
      const cardBgColor = section.dataset.cardBgColor || "#ffffff"
      const desktopColumns = section.dataset.desktopColumns || "4"
      const mobileColumns = section.dataset.mobileColumns || "1"

      // 更新 grid columns
      desktopList.style.gridTemplateColumns = `repeat(${desktopColumns}, 1fr)`
      mobileList.style.gridTemplateColumns = `repeat(${mobileColumns}, 1fr)`

      // 清空现有列表
      desktopList.innerHTML = ""
      mobileList.innerHTML = ""

      // 遍历图片数组，通过索引匹配文案
      images.forEach((imageUrl, index) => {
        const text = texts && texts[index] ? texts[index] : ""

        const imageHtml = imageUrl
          ? `<div class="w-full h-45 mb-6 flex items-center justify-center" style="width: 100% !important; margin-bottom: 1.5rem !important;">
              <img 
                src="${imageUrl}"
                alt="${this.escapeHtml(text)}"
                width="300"
                height="180"
                loading="lazy"
                class="w-auto h-full object-contain accessory-image"
                style="max-width: 100%; height: auto !important;"
              >
            </div>`
          : ""

        const itemHtml = `
          <li class="accessory-item flex flex-col items-center justify-center p-6 rounded-lg bg-white shadow-md" style="background: ${cardBgColor}; display: flex !important; flex-direction: column !important;">
            ${imageHtml}
            <div class="text-center w-full" style="width: 100% !important;">
              <p class="text-xl font-bold mb-3 accessory-text" style="font-weight: 700 !important; font-size: 1.25rem !important; margin-bottom: 0.75rem !important; line-height: 1.4 !important;">${this.escapeHtml(text)}</p>
            </div>
          </li>
        `

        desktopList.insertAdjacentHTML("beforeend", itemHtml)
        mobileList.insertAdjacentHTML("beforeend", itemHtml)
      })
    })
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }

  updateRecommendedAccessories(product) {
    // 查找所有推荐配件 section
    const recommendedSections = document.querySelectorAll(".sec__recommended-accessories")
    if (!recommendedSections || recommendedSections.length === 0) return

    const recommendedProducts = product.recommended_accessories || []

    // 如果没有推荐产品，清空列表
    if (!recommendedProducts || recommendedProducts.length === 0) {
      recommendedSections.forEach((section) => {
        const productsContainer = section.querySelector(".recommended-accessories-products")
        if (productsContainer) {
          productsContainer.innerHTML = '<p class="text-center w-full">No recommended accessories available.</p>'
        }
      })
      return
    }

    // 使用元字段中缓存的数据直接渲染产品卡片
    recommendedSections.forEach((section) => {
      const productsContainer = section.querySelector(".recommended-accessories-products")
      if (!productsContainer) return

      // 清空现有内容
      productsContainer.innerHTML = ""

      // 遍历推荐产品，生成产品卡片 HTML
      recommendedProducts.forEach((recProduct) => {
        if (!recProduct || !recProduct.id) return

        const productCardHtml = this.buildProductCardHTML(recProduct)
        productsContainer.insertAdjacentHTML("beforeend", productCardHtml)
      })

      // 如果没有产品，显示提示
      if (recommendedProducts.length === 0) {
        productsContainer.innerHTML = '<p class="text-center w-full">No recommended accessories available.</p>'
      }
    })
  }

  buildProductCardHTML(product) {
    // 处理图片 URL
    let imageUrl = product.featured_image || ""
    if (typeof imageUrl === "object" && imageUrl !== null) {
      imageUrl = imageUrl.src || imageUrl.url || ""
    }

    // 处理价格
    const price = product.price || 0
    const comparePrice = product.compare_at_price || null
    const hasDiscount = comparePrice && comparePrice > price && comparePrice > 0

    // 格式化价格
    const formattedPrice = price > 0 ? this.formatMoney(price) : ""
    const formattedComparePrice = hasDiscount && comparePrice ? this.formatMoney(comparePrice) : ""

    // 构建价格 HTML（使用与 price snippet 类似的结构）
    let priceHtml = ""
    if (formattedPrice) {
      if (hasDiscount) {
        priceHtml = `
          <div class="product-item__price flex gap-3 lh-normal" style="--font-size: 14px; align-items: center; justify-content: center;">
            <span class="price-item price heading-style font-bold">
              ${formattedPrice}
            </span>
            <span class="price-item compare-price text-xs" style="color: #737373;">
              <s>${formattedComparePrice}</s>
            </span>
          </div>
        `
      } else {
        priceHtml = `
          <div class="product-item__price flex gap-3 lh-normal" style="--font-size: 14px; align-items: center; justify-content: center;">
            <span class="price-item price heading-style font-bold">
              ${formattedPrice}
            </span>
          </div>
        `
      }
    }

    // 构建产品卡片 HTML（简化版本，匹配 product-item 的基本结构）
    return `
      <div class="product-item product__item-js" data-update-url="false">
        <div class="product-item__wrapper block product-grid">
          <div class="product-item__inner hover-effect overflow-hidden relative">
            ${imageUrl ? `
              <a href="${product.url || "#"}" class="product-item__link block relative" aria-label="${this.escapeHtml(product.title || "")}">
                <div class="product-item__image-wrapper relative" style="--aspect-ratio: 1/1; width: 100%;">
                  <img
                    src="${imageUrl}"
                    alt="${this.escapeHtml(product.title || "")}"
                    loading="lazy"
                    class="product-item__image w-full h-full object-cover"
                    width="600"
                    height="600"
                  />
                </div>
              </a>
            ` : `
              <div class="product-item__image-wrapper relative" style="--aspect-ratio: 1/1; width: 100%; background-color: #f5f5f5;">
              </div>
            `}
          </div>
          <div class="product-item__information word-break text-center mt-15">
            <a
              href="${product.url || "#"}"
              class="product-item__name heading-style no-underline block lh-normal"
              aria-label="${this.escapeHtml(product.title || "")}"
              style="font-size: 1rem; line-height: 1.4; margin-bottom: 0.5rem;"
            >
              ${this.escapeHtml(product.title || "")}
            </a>
            ${priceHtml}
          </div>
        </div>
      </div>
    `
  }
}

customElements.define("product-switcher", ProductSwitcher)

// 页面加载时检查当前 URL，隐藏特定元素
(function() {
  function checkAndHideDiv() {
    const targetDiv = document.querySelector(".shopify-block-AN0ZoRU1lZUszanNRW__custom_liquid_zaNLBU")
    if (targetDiv && window.location.pathname === "/products/dji-mavic-4-pro") {
      targetDiv.style.display = "none"
    }
  }
  
  // DOM 加载完成后执行
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", checkAndHideDiv)
  } else {
    checkAndHideDiv()
  }
  
  // 监听 URL 变化（处理浏览器前进/后退）
  window.addEventListener("popstate", checkAndHideDiv)
})()
